import BaseModel from '../core/BaseModel'
export default class RequestActivationLogChangeViewModel extends BaseModel {
    constructor() {
        super({ 
                name: "view_request_activation_history_detail",
                tableName: 'view_request_activation_history_detail'
            }, 
            {
                id_log: { 
                    name: 'id_log', 
                    type: "String", 
                    label: 'ID', 
                    primaryKey: true,
                    display: false
                },
                modified_date: { 
                    name: 'modified_date', 
                    type: "Date", 
                    label: 'Thời gian cập nhật',
                    class: 'center',
                },
                
    
                full_name: { 
                    name: 'full_name', 
                    type: "String", 
                    label: 'Người cập nhật',
                    class: 'center'
                },
                organization_name: { 
                    name: 'organization_name', 
                    label: 'Đơn vị cập nhật',
                    class: 'center',
                    type: "String"
                },
                message: { 
                    name: 'message', 
                    label: 'Nội dung cập nhật'
                },
                verify_status: { 
                    name: 'verify_status', 
                    type: "Selection",
                    label: 'Trạng thái nghiệm thu',
                    dataType: 'Label',
                    class: 'center',
                    options: [{ value: 1, label: 'Đã nghiệm thu'}, { value: 0, label: 'Chờ nghiệm thu'}, { value: 2, label: 'Không nghiệm thu'}],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals'}
                },
                warranty_status: { 
                    name: 'warranty_status', 
                    type: "Selection",
                    label: 'Trạng thái bảo hành',
                    dataType: 'Label',
                    class: 'center',
                    options: [{ value: 0, label: 'Chưa kích hoạt'}, { value: 2, label: 'Chờ kích hoạt'}, { value: 3, label: 'Đã kích hoạt'}, { value: 4, label: 'Hết bảo hành'}, { value: 6, label: 'Sản phẩm huỷ'}],
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                    computed: (data) => {
                        data.warranty_status = (data.warranty_status == 5) ? 0 : data.warranty_status;
                    }
                }
        },)
    }

}